module.exports = __webpack_public_path__ + "assets/images/premium-locked-screen/shift-tasks/task-list-8e86e5.svg";